import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DistrictDto} from '../../../../generated-model/models';
import {PageResponse} from '../../../shared/commons/page-response';

@Injectable({providedIn: 'root'})
export class DistrictService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/master/districts';

  getAllDistricts(page: number, size: number, search: string = "", state: number | null = null): Observable<PageResponse<DistrictDto>> {
    return this.http.get<PageResponse<DistrictDto>>(this.apiUrl + '?page=' + page + '&size=' + size + '&search=' + encodeURIComponent(search) + (state == null ? '' : '&state=' + state));
  }

  getDistrictById(id: number): Observable<DistrictDto> {
    return this.http.get<DistrictDto>(`${this.apiUrl}/${id}`);
  }

  createDistrict(district: DistrictDto): Observable<DistrictDto> {
    return this.http.post<DistrictDto>(this.apiUrl, district);
  }

  updateDistrict(id: number, district: DistrictDto): Observable<DistrictDto> {
    return this.http.put<DistrictDto>(`${this.apiUrl}/${id}`, district);
  }

  deleteDistrict(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
